module.exports = "/next-static/_next/static/images/block_image_three-ee2a8ca0e6e7e4f0c27b5b53129f6dbd.png";